import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzVday65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_65: Record<
  Exclude<PageIdWoofzVday65, PageIdWoofzVday65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_VDAY_65]: {
    id: PageId.SUBSCRIPTIONS_VDAY_65,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_VDAY_65]: {
    id: PageId.CHAT_UPSELL_VDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_VDAY_65]: {
    id: PageId.UPSELL_VDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_VDAY_65]: {
    id: PageId.DOWNLOAD_VDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
